angular.module('TetherApp').factory('messageService', [
    '$http',
    function ($http) {
        let randomString = function (length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let getParticipantMessages = function (page, id, shortcodeId) {
            let uri = '/api/v1/messages/participant/' + id + '/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            let requestData = {};
            if (page != undefined) {
                requestData.page = page;
            }
            if (shortcodeId != undefined) {
                requestData.shortcode = shortcodeId;
            }
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' },
                    data: requestData
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let send = function (data) {
            return $http.post('/api/v1/messages/send', data, {
                cache: false,
                headers: { 'Cache-Control' : 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        };

        let sendExperienceRequestEvent = function (participant, experience) {
            return $http.post(
                '/api/v1/events/conversation',
                {
                    experience: experience,
                    participant: participant
                },
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        return {
            getParticipantMessages: getParticipantMessages,
            sendExperienceRequestEvent : sendExperienceRequestEvent,
            send: send
        };
    }
]);
